import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import InstallationSettingIndex from "../../../../components/SidetabPages/Configuration/InstallationSetting/InstallationSettingIndex";

const InstallationSetting = () => {
  return (
    <>
      <AnnouncementBar />
      <InstallationSettingIndex />
    </>
  );
};
export default InstallationSetting;
